import React from 'react';
import ChipInput from 'material-ui-chip-input';
import Chip from 'material-ui/Chip';
import Avatar from 'material-ui/Avatar';
import {green800, green300, red300, red800, orange300, orange800} from 'material-ui/styles/colors';

export function createFilterChip(type, listText, text, displayText, color, focusedColor, filterFn, isVariable=false ) {
    return {
        text: listText, // how the value is presented in the drop down
        value: {
            type: type, // relevant for visual chip factory
            text: text, // matches the search string, only relevant for variable chips for now
            displayText: displayText, // shows on the chip
            color: color,
            focusedColor: focusedColor,
            filter: filterFn, // the actual filter object to pass to executeFilter
            isVariable: isVariable, // if this filter is dynamic, i.e based on search input
        }
    }
}
function getGroupItem(name, short) {
    return createFilterChip('GROUP', 'Group: '+name, short, short, green300, green800);
}
// filter factory
export const generateVariableFilterChip = (
        listDisplayFn = (t) => t,
        type,
        displayFn = (t) => t,
        color,
        focusedColor,
        filterFn = (t) => (item, extra) => true
    ) => (searchString) => {
    return createFilterChip(type,
        listDisplayFn(searchString),
        searchString,
        displayFn(searchString),
        color,
        focusedColor,
        filterFn(searchString),
        true )
};

const originalDataSource = [
    getGroupItem('Night Shift', 'NS'),
    getGroupItem('Day Shift', 'DS'),
    getGroupItem('Beta', 'ß'),
    createFilterChip('W', 'In Work Session', 'W', red300, red800),
    createFilterChip('A', 'Active', 'Active', orange300, orange800),
];

class ChipFilterInput extends React.Component {

    constructor(props) {
        super(props);
        this.state={
            dataSource:[...this.props.filterChips],
            chips:[]
        }
        this.handleUpdateInput= this.handleUpdateInput.bind(this);
        this.handleRequestAdd= this.handleRequestAdd.bind(this);
        this.handleRequestDelete= this.handleRequestDelete.bind(this);
        this.setChipInput= this.setChipInput.bind(this);
        this.executeFilter= this.executeFilter.bind(this);
    }

    handleUpdateInput(searchString, dataSource, params) {
        // Update variable chips based on the current input
        const variableChips = (this.props.filterChipsFactories||[]).map(f => f(searchString));
        this.setState({
            dataSource:[...this.props.filterChips, ...variableChips]
        });
    }
    filter(searchText, key) {
        return searchText !== '' && key.indexOf(searchText) !== -1;
    }
    handleRequestDelete(chip) {
        this.setState({
            chips: this.state.chips.filter((c) => c.value !== chip)
        }, this.executeFilter)
    }
    handleRequestAdd(chip) {
        let toAdd = null;
        // handle plain text input as from onBlur event
        if ( typeof chip === 'string' ) {
            chip = {text:chip,  value:chip}

        }
        // Simple case, the chip is indeed a matched chip from dataSource
        if ( chip.value.type) {
            toAdd = chip;
        } else {
            // Less simple case, the "chip" is user input
            toAdd=this.state.dataSource.find(c => {
                const inList = this.filter(chip.text.toUpperCase(), c.text.toUpperCase());
                let inCurrentChips = false;
                if( c.value.isVariable ) {
                    inCurrentChips = !!this.state.chips.find((c2) => c2.value.text === c.value.text)
                } else {
                    inCurrentChips = !!this.state.chips.find((c2) => c2 === c);

                }
                return inList && !inCurrentChips;

            });
        }
        this.chipInput.autoComplete.setState({open:false});

        if( toAdd) {
            this.setState({
                chips:[...this.state.chips, toAdd]
            }, this.executeFilter);
        }
    }
    executeFilter() {
        const filters = this.state.chips.map(c => c.value.filter);
        this.props.applyFilter(filters);
    }
    setChipInput(chipInput) {
        this.chipInput = chipInput;
    }
    render() {
        return (
            <ChipInput
                ref={this.setChipInput}
                fullWidth
                // onBlur={(event) => {
                //     this.handleRequestAdd(event.target.value);
                //     this.chipInput.autoComplete.setState({searchText:''});
                //
                // }}
                value={this.state.chips}
                newChipKeyCodes={[13, 188, 32, 9]}
                onRequestAdd={this.handleRequestAdd}
                onRequestDelete={this.handleRequestDelete}
                onUpdateInput={this.handleUpdateInput}
                dataSource={this.state.dataSource}
                dataSourceConfig={{text:'text', value:'value'}}
                chipRenderer={({ value, isFocused, isDisabled, handleClick, handleRequestDelete }, key) => (
                    <Chip
                        key={key}
                        style={{ margin: '8px 8px 0 0', float: 'left', pointerEvents: isDisabled ? 'none' : undefined }}
                        backgroundColor={isFocused ? value.focusedColor : value.color}
                        onTouchTap={handleClick}
                        onRequestDelete={handleRequestDelete}
                    >
                        <Avatar size={24}>{value.type[0].toUpperCase()}</Avatar>
                        {value.displayText}
                    </Chip>
                )}
            />
        )
    }
}
export default ChipFilterInput;
ChipFilterInput.defaultProps = {
    filterChipsFactories:[],
}

ChipFilterInput.propTypes = {
    applyFilter:React.PropTypes.func.isRequired,
    filterChips:React.PropTypes.array.isRequired,
    filterChipsFactories:React.PropTypes.arrayOf(React.PropTypes.func),

}


// WEBPACK FOOTER //
// ./src/ui/components/ChipFilterInput.js